import dayjs from 'dayjs';

export type LogType = 'log' | 'warn' | 'error';
export type Logger = (type: LogType, ...args: any[]) => void;

export const isDebugMode = !!localStorage.getItem(window.location.host);
export const log: Logger = isDebugMode
  ? (type, ...args) => console[type](dayjs().format(), '@', ...args)
  : () => undefined;

export function getLogger(group: string): Logger {
  return (type, ...args) => log(type, `[${group}]:`, ...args);
}
